<template>
	<div class="faqs-section">
		<h3 class="faqs-title">For peace of mind....</h3>
		<div class="faqs-container">
			<div
				v-for="(faq, index) in displayedFaqs"
				:key="index"
				class="faq-item"
			>
				<div class="faq-question" @click="toggleFaq(index)">
					<span class="question-text">{{ faq.question }}</span>
					<span class="chevron" :class="{ expanded: expandedIndex === index }">›</span>
				</div>
				<transition name="expand-answer">
					<div v-if="expandedIndex === index" class="faq-answer">
						{{ faq.answer }}
					</div>
				</transition>
			</div>
		</div>
		<button v-if="limit !== null" class="read-all-link" @click="goToAllFaqs">
			<span>Read all FAQs</span>
			<!-- <span class="external-icon"><img :src="require('@/assets/linkto.png')"></span> -->
		</button>
	</div>
</template>

<script>
export default {
	name: 'FaqsSection',
	props: {
		faqs: {
			type: Array,
			default: () => []
		},
		limit: {
			type: Number,
			default: null
		},
		faqName: {
			type: String,
			default: null
		}
	},
	computed: {
		displayedFaqs() {
			if (this.limit) {
				return this.faqs.slice(0, this.limit);
			}
			return this.faqs;
		}
	},
	data() {
		return {
			expandedIndex: null
		};
	},
	methods: {
		toggleFaq(index) {
			this.expandedIndex = this.expandedIndex === index ? null : index;
		},
		goToAllFaqs() {
			const route = this.faqName ? `/faqs?name=${this.faqName}` : '/faqs';
			this.$router.push(route);
		}
	}
};
</script>

<style scoped>
.faqs-section {
	/* margin-left: -20px;
	margin-right: -20px; */
	margin-top: 24px;
	padding: 20px;
}

.faqs-title {
	font-size: 15px;
	margin-bottom: 16px;
	font-weight: bold;
	text-align: center;
}

.faqs-container {
	display: flex;
	flex-direction: column;
}

.faq-item {
	border: none;
	border-bottom: 1px solid #C6CAE5;
	overflow: hidden;
}

.faq-item:last-child {
	border-bottom: none;
}

.faq-question {
	padding: 16px 0px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	transition: background-color 0.2s ease;
	font-size: 16px;
}

.question-text {
	font-size: 16px;
	flex: 1;
}

.chevron {
	font-size: 20px;
	color: #413655;
	transition: transform 0.3s ease;
	flex-shrink: 0;
	margin-left: 12px;
}

.chevron.expanded {
	transform: rotate(90deg);
}

.faq-answer {
	padding: 0 0 16px 0; 
	font-size: 16px;
}

.read-all-link {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin: 16px auto 0;
	font-size: 13px;
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	color: #413655;
	transition: opacity 0.2s ease;
}

.read-all-link:hover {
	opacity: 0.7;
}

.external-icon {
	width: 16px;
	height: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.external-icon img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.expand-answer-enter-active,
.expand-answer-leave-active {
	transition: all 0.3s ease;
}

.expand-answer-enter-from,
.expand-answer-leave-to {
	opacity: 0;
	max-height: 0;
}

.expand-answer-enter-to,
.expand-answer-leave-from {
	opacity: 1;
	max-height: 500px;
}
</style>
